import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { NameIdObj } from 'common/models/GenericTypes';
import MultipleUserPicker from 'components/Pickers/MultipleUserPicker';
import React, { useCallback, useEffect, useState } from 'react';
import { BulkSetOpportunityOwners } from 'services/OpportunitiesService';

interface Props {
  open: boolean;
  opportunityIds: number[];
  closeHandler: () => void;
  loadingHandler?: (isLoading: boolean) => void;
  successHandler?: (message: string, ownerIds: number[]) => void;
  errorHandler?: (message: string) => void;
}

export default function ChangeOpportunityOwnersDialog({
  open,
  opportunityIds,
  closeHandler,
  loadingHandler,
  successHandler,
  errorHandler,
}: Props) {
  const [ownerIds, setOwnerIds] = useState<number[]>([]);

  useEffect(() => {
    if (open) {
      setOwnerIds([]);
    }
  }, [open]);

  const submitCallback = useCallback(async () => {
    loadingHandler?.(true);
    const res = await BulkSetOpportunityOwners(opportunityIds, ownerIds, errorHandler);
    if (res) {
      successHandler?.('Saved Changes', ownerIds);
      closeHandler();
    }
    loadingHandler?.(false);
  }, [opportunityIds, ownerIds, closeHandler, loadingHandler, errorHandler, successHandler]);

  const ownersChangeHandler = useCallback((users: NameIdObj[]) => {
    setOwnerIds(users.map((u) => u.id));
  }, []);

  return (
    <Dialog open={open} maxWidth="md">
      <DialogTitle>Confirm Action</DialogTitle>
      <DialogContent>
        <DialogContentText mb={2}>
          {opportunityIds.length > 1 &&
            `Are you sure you want to change the ownership of the ${opportunityIds.length} selected
            opportunities?`}
          {opportunityIds.length === 1 &&
            'Are you sure you want to change the ownership of the selected opportunity?'}
        </DialogContentText>
        <MultipleUserPicker label="Owners" value={ownerIds} onSelect={ownersChangeHandler} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={closeHandler}>
          No
        </Button>
        <Button variant="contained" color="success" onClick={submitCallback}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
